<template>
  <div class="px-4 whitespace-nowrap" :class="options.classNames">
    <icon-base
      v-if="!!options?.icon"
      :icon="options.icon"
      :icon-color="options.iconColor ?? null"
    />

    <span>{{ options.label }}</span>
  </div>
</template>

<script setup lang="ts">
import type { TableSelectOptions } from "@/models/common";

defineProps<{ options: TableSelectOptions }>();
</script>
